import { Tree } from 'antd'
import { YhBox } from "@/components/YhBox";
import '../approval.less'

import type { DataNode } from 'antd/es/tree';

export const Left = () => {

  const treeData: DataNode[] = [
    {
      title: '临时授信账户调额',
      key: '1',
    }
  ];

  return (
    <YhBox width="100%" height="100%" title="选择事项">
      <Tree
        className="p-5"
        treeData={treeData}
      />
    </YhBox>
  )
}